export default "__VITE_ASSET__0e4391a0__"